import { deleteCookie } from "../cookie";


var logOut = () => {
    deleteCookie("user");
    window.location.href = "./login";
}

export default logOut;